import React, { useEffect, useState } from "react";
import { Tab as TabComponent } from "../../secondary";
import { Measurement } from "./Measurement/measurement";
import style from "./assessmentDetail.module.scss";
import anatomystyles from "./characteristic.module.scss";
import { Button } from "../../primary/Button/button";
import { Treatment } from "./Treatment/treatment";
import { AssessmentNotes } from "./Notes/assessmentNotes";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAsync, deleteParentChildAsync, setLoading } from "../../../app/appSlice";
import {
  detailAssessmentAsync,
  setDetailAssessment,
  setWoundMeasurementData,
  setHealingTrajectoryData,
  patientDetailsAsync,
  optionTypeAsync,
  ne1getWounAssessmentDetailAsync,
  ne1configsignwithoutmindatasetAsync,
  setCharStatus,
  setNe1getWounAssessmentDetail,
  setAssessmentHistory,
  patientAssessmentAsync,
  patientAssessmentHistoryAsync,
} from "../../../app/patientSlice";
import { SignAndLock } from "./signAndLock";
import { allNullCheck } from "../../../utils";
import { AssessmentHistory } from "../../core/Patients/assessmentHistory";
import { HealingTrajectory } from "../../core/Patients/healingTrajectory";
import { assessmentRbacChecker } from "../../../utils/rbac";
import { DELETE_CHILD_ASSESSMENT, DELETE_HISTORY_ASSESSMENT } from "../../../constants";
import { CharacteristicAnatomy } from "./characteristicAnatomy";
import { Photos } from "./Photos";
import CustomLabels from "./customLabels";
import { getHistoryCauseText } from "../../../utils/getHistoryCauseText";
import WoundAssessmentCard from "./WoundAssessment/woundAssessmentCard";
import PatientCard from "./patientCard";
import PdfImageConfirmationModal from "./pdfImageConfirmationModal";
import { MoreInfoModal } from "../MoreInfoModal/MoreInfoModal";
import { useLoading } from "../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../constants/loadingKeys";
import { Spinner } from "../../secondary/Loader/Spinner";
import { Characteristic } from "./Characteristic/Characteristic";

export const AssessmentDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { assessmentId, patientId } = useParams();

  const patientData = useSelector((state) => state.patient.detailViewData);
  const assessmentHistoryData = useSelector((state) => state.patient.assessmentHistory);
  const isIndividualPatientLoading = useLoading(LOADING_KEYS.INDIVIDUAL_PATIENT);
  const historyCause = useSelector((state) => state.patient.historyCause);
  const detailAssessment = useSelector((state) => state.patient.detailAssessment);
  const ne1getWounAssessmentDetailData = useSelector((state) => state.patient.ne1getWounAssessmentDetail);
  const allWoundClassificationList = useSelector((state) => state.patient.allWoundClassificationList);
  const userDetails = useSelector((state) => state.user);

  const hideIt = assessmentRbacChecker(userDetails?.role, patientData?.isOwnCustomer);

  const [childLevelDelete, setChildLevelDelete] = useState(false);
  const [newWoundOptionChildLevel, setNewWoundOptionChildLevel] = useState(false);
  const [tabIndex, setTabIndex] = useState(1);

  /* Register mobile app modal */
  const [modalShow, setmodalShow] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    dispatch(patientDetailsAsync(patientId));
  }, [patientId]);

  useEffect(() => {
    dispatch(optionTypeAsync("humananatomy"));
    dispatch(optionTypeAsync("woundprogress"));
  }, [dispatch])

  useEffect(() => {
    dispatch(setDetailAssessment(null));
    dispatch(setNe1getWounAssessmentDetail({}));
    dispatch(setCharStatus([]));
    dispatch(ne1getWounAssessmentDetailAsync({ patientId, assessmentId }));
    dispatch(setHealingTrajectoryData([]));
    dispatch(setWoundMeasurementData(null));
    // dispatch(checkAutoMeasurementStatusAsync(patientId, assessmentId));
    dispatch(detailAssessmentAsync({ patientId, assessmentId }));
    dispatch(ne1configsignwithoutmindatasetAsync({ patientId, assessmentId }));
  }, [dispatch, patientId, assessmentId]);

  const getCharDetails = () => {
    // Dispatching get assessment details call
    dispatch(detailAssessmentAsync({ patientId, assessmentId }));
    dispatch(ne1getWounAssessmentDetailAsync({ patientId, assessmentId }));
  };
  const tabList = [
    {
      name: "Anatomy",
      key: "anatomy",
      content: (
        <CharacteristicAnatomy
          styles={anatomystyles}
          dispatch={dispatch}
          patientId={patientId}
          assessmentId={assessmentId}
          assessmentDetails={detailAssessment}
          getCharDetails={getCharDetails}
          hideIt={hideIt}
        />
      ),
    },
    {
      name: "Characteristics",
      key: "characteristics",
      content: <Characteristic hideIt={hideIt} />,
    },
    {
      name: "Measurements",
      key: "measurements",
      content: <Measurement hideIt={hideIt} />,
    },
    {
      name: "Treatment",
      key: "treatment",
      content: <Treatment />,
    },
    {
      name: "Notes",
      key: "notes",
      content: <AssessmentNotes hideIt={hideIt} />,
    },
    {
      name: "Healing Trajectory",
      key: "healingTrajectory",
      content: <HealingTrajectory detailAssessment={detailAssessment} patientId={patientId} assessmentId={assessmentId} dispatch={dispatch} />,
    },
    {
      name: "Photos",
      key: "photos",
      content: <Photos />,
    },
  ];

  const navigateToPdf = (isWoundImages = false) => {
    dispatch(setLoading(true));
    navigate(
      `/patients/${patientId}/assessment/${detailAssessment.id}/pdfdownload`,
      {
        state: isWoundImages
      }
    );
  };

  const modalOpen = () => setmodalShow(true);

  const pdfmodalopen = () => setPdfModal(true);

  const deleteAssessmentChildLevel = (assessmentId) => {
    const finalArrValue = parseInt(
      assessmentHistoryData?.followuphistory?.map((data) => data?.assessments?.filter((item) => item.id !== assessmentId))?.map((item) => item[0]?.id)
    );
    const payload = {
      patientId: patientId,
      assessmentId: assessmentId,
    };
    const deleteURL = DELETE_CHILD_ASSESSMENT;
    dispatch(setAssessmentHistory({}));
    dispatch(deleteParentChildAsync(payload, deleteURL, patientAssessmentAsync, patientAssessmentHistoryAsync, finalArrValue));
    setChildLevelDelete(true);
  };

  const deleteHistoryAssessment = (assessmentId, historyAssessmentId) =>
    dispatch(deleteAsync(DELETE_HISTORY_ASSESSMENT, patientId, assessmentId, historyAssessmentId));

  const handleTabSelect = (index) => {
    setTabIndex(index);
  };

  return (
    <>
      {isIndividualPatientLoading ? (
        <Spinner className={style.main_detail_loader} />
      ) : (
        <>
          <div>
            {moreInfoModal && (
              <MoreInfoModal moreInfoModal={moreInfoModal} setMoreInfoModal={setMoreInfoModal} assessmentId={assessmentId} />
            )}
            <div className={`${style.tab_container}`}>
              <>
                <div className={`col-12`}>
                  <div className={`row`}>
                    <PatientCard setPatientMoreInfo={setMoreInfoModal} />

                    <div className={`{col-6}`}>
                      <div className={`${style.patient_heading_details} pb-3`}></div>

                      <div className={`${style.body_heading}`}>
                        <span>
                          {
                            <>
                              {detailAssessment?.title ? detailAssessment?.title : null}
                              &nbsp;
                              {ne1getWounAssessmentDetailData && Object.keys(ne1getWounAssessmentDetailData).length !== 0 && (
                                <SignAndLock
                                  ne1getWounAssessmentDetailData={ne1getWounAssessmentDetailData}
                                  assessmentDetail={detailAssessment}
                                  hideIt={hideIt}
                                  userDetails={userDetails}
                                  patientData={patientData}
                                />
                              )}
                            </>
                          }
                        </span>
                      </div>
                      <div className={`mb-3`}>
                        <div className={`${style.assess_content} mt-4`}>
                          <span className={`${style.assess_label} pt-4`}>History/Cause: &#173;</span>
                          <span>{getHistoryCauseText(detailAssessment?.historyCause, historyCause)}</span>
                        </div>
                        <CustomLabels />

                        <div className={`${style.assess_content} mb-4 WoundAcquired`}>
                          <span className={style.assess_label}>Wound Acquired: &#173;</span>
                          {detailAssessment?.woundAcquired ? (
                            <span className={detailAssessment?.woundAcquired === "NON-POA" ? style.NONPOAColor : style.POAColor}>
                              {detailAssessment.woundAcquired}
                            </span>
                          ) : (
                            "NA"
                          )}
                        </div>

                        <div className={`${style.assess_content} mb-4`}>
                          <span className={`${style.assess_label}`}>Classification: </span>
                          <span className={style.classifi_content}>
                            {" "}
                            {detailAssessment?.classification?.woundClassification &&
                            detailAssessment?.classification?.woundClassification !== "unknown" &&
                            allNullCheck(detailAssessment?.classification?.woundClassification)
                              ? allWoundClassificationList?.find((item) => item.key === detailAssessment?.classification?.woundClassification)
                                  ?.value || "Unknown"
                              : "Unknown"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className={`{col-6}`}></div>
                  </div>
                  <WoundAssessmentCard assessment={detailAssessment} modalOpen={modalOpen} />
                </div>
              </>
            </div>

            {(detailAssessment?.assessmentStage === "pendingreview" || detailAssessment?.assessmentStage === "signedlocked") && (
              <div className={style.PDFButton}>
                <Button
                  type="submit"
                  value="Download PDF"
                  id="tes"
                  onClick={detailAssessment?.isWoundWithoutPhoto === 0 ? pdfmodalopen : () => navigateToPdf(true)}
                  classes={{ className: `btn pr-3 pl-3 ${style.btn_custom}` }}
                />
              </div>
            )}

            {pdfModal && <PdfImageConfirmationModal modalOpen={pdfModal} setModalOpen={setPdfModal} navigateToPdf={navigateToPdf} />}

            {modalShow && (
              <AssessmentHistory
                modalOpen={modalShow}
                modalClose={"modalClose"}
                setmodalShow={setmodalShow}
                modalTitlteId={assessmentId}
                assessmentTitle={detailAssessment.title}
                deleteAssessment={deleteAssessmentChildLevel}
                deleteHistoryAssessment={deleteHistoryAssessment}
                setChildLevelDelete={setChildLevelDelete}
                childLevelDelete={childLevelDelete}
                setNewWoundOptionChildLevel={setNewWoundOptionChildLevel}
                modalType="assessmentDetail"
              />
            )}
            <TabComponent tabList={tabList} selectedIndex={tabIndex} onSelect={handleTabSelect} />
          </div>
        </>
      )}
    </>
  );
};
